import { BASE_URL } from "./config";

// ✅ Get all blogs
export const getBlogs = async () => {
  try {
    const res = await fetch(`${BASE_URL}/blog/active`);

    if (!res.ok) throw new Error("Failed to fetch blogs");

    const data = await res.json();
    return data.data; // ⚠️ important
  } catch (err) {
    console.error("Error fetching blogs:", err);
    return [];
  }
};

// ✅ Get blog by ID
export const getBlogById = async (id) => {
  try {
    const res = await fetch(`${BASE_URL}/blog/${id}/detail`);

    if (!res.ok) throw new Error("Failed to fetch blog detail");

    const data = await res.json();
    return data.data; // ⚠️ important
  } catch (err) {
    console.error("Error fetching blog detail:", err);
    return null;
  }
};